import store from '@/store'

export function getDicts(type){
	const dicts = store.getters && store.getters.dicts
	if(!dicts)return [];
	return dicts.filter(item=>{return item.dictType==type})
}
export function getDictByTypeAndLabel(type,label){
	const dicts = store.getters && store.getters.dicts
	if(!dicts)return "";
	const dicttypes = dicts.filter(item=>{return item.dictType==type})
	for(const d of dicttypes){
		if(d.dictLabel == label){
			return d;
		}
	}
}
export function getDictLabel(type,value){
	const dicts = store.getters && store.getters.dicts
	if(!dicts)return "";
	const dicttypes = dicts.filter(item=>{return item.dictType==type})
	for(const d of dicttypes){
		if(d.dictValue == value){
			return d.dictLabel;
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/dicts.js